import React from 'react'
import { Form, Row, Col } from 'antd'
import { Select, Input, TextArea, RadioGroup } from 'ui/styled'
import EnumSelect from 'components/EnumSelect'
import { getNumberRules } from 'utils/numberHelper'
import { ZIP_CODE_MAX_LENGTH, ZIP_CODE } from 'constants/constants'
import NumberInput from 'components/NumberInput/NumberInput'
import { Label } from 'pages/Ticket/styled'
import {
  FIRST_TIME_VISIT_OPTIONS,
  RESPONSE_THRESHOLD_OPTIONS,
  HEALTH_ISSUE_OPTIONS,
  PREFERRED_DISTANCE_OPTIONS
} from 'pages/Ticket/CarePlanDetails/helpers'

const { Item } = Form

const DATA_TEST = {
  image_type: 'createNewTicketPageRequestType',
  severity_rating: 'createNewTicketPageSeverityRating',
  request_notes: 'createNewTicketPageUserNotesArea',
  health_issue: 'createNewTicketPageHealthIssue',
  first_time_visit: 'createNewTicketPageFirstTimeVisit',
  response_threshold: 'createNewTicketResponseThreshold',
  zip: 'createNewTicketPageLocation',
  special_needs: 'createNewTicketPageUserSpecialNeeds',
  provider_name: 'createNewTicketPageProviderName',
  preferred_distance: 'createNewTicketPagePreferredDistance'
}

const FindCareFields = () => (
  <>
    <Row gutter={[16, 0]}>
      <Col span={24}>
        <Label required>Request Type</Label>
        <Item
          name="image_type"
          rules={[
            {
              required: true,
              message: 'Request Type required!'
            }
          ]}
        >
          <EnumSelect
            enum_name="ROADMAP_IMAGE_TYPE"
            placeholder="Request type"
            showSearch
            data-test={DATA_TEST.image_type}
          />
        </Item>
      </Col>
    </Row>
    <Label>Request Notes</Label>
    <Item name="request_notes">
      <TextArea
        autoSize={{ minRows: 2, maxRows: 10 }}
        rows={6}
        placeholder="Notes to add to the user"
        data-test={DATA_TEST.request_notes}
      />
    </Item>
    <Row gutter={[16, 0]}>
      <Col span={7}>
        <Label>New / Ongoing</Label>
        <Item name="health_issue">
          <RadioGroup
            data-test={DATA_TEST.health_issue}
            options={HEALTH_ISSUE_OPTIONS}
          />
        </Item>
      </Col>
      <Col span={5}>
        <Label>Provider seen</Label>
        <Item name="first_time_visit">
          <RadioGroup
            data-test={DATA_TEST.first_time_visit}
            options={FIRST_TIME_VISIT_OPTIONS}
          />
        </Item>
      </Col>
      <Col span={12}>
        <Label>Urgency</Label>
        <Item name="response_threshold">
          <RadioGroup
            data-test={DATA_TEST.response_threshold}
            options={RESPONSE_THRESHOLD_OPTIONS}
          />
        </Item>
      </Col>
    </Row>
    <Row gutter={[16, 0]}>
      <Col span={12}>
        <Label required>Location Data</Label>
        <Item
          name="preferred_address"
          rules={getNumberRules({
            maxLength: ZIP_CODE_MAX_LENGTH,
            type: ZIP_CODE,
            isRequired: true
          })}
        >
          <NumberInput
            type="zip"
            placeHolder="ZIP"
            maxLength={ZIP_CODE_MAX_LENGTH}
            data-test={DATA_TEST.zip}
          />
        </Item>
      </Col>
      <Col span={12}>
        <Label>Preferred Distance</Label>
        <Item name="preferred_distance">
          <Select
            options={PREFERRED_DISTANCE_OPTIONS}
            data-test={DATA_TEST.preferred_distance}
          />
        </Item>
      </Col>
    </Row>
    <Label>Provider name</Label>
    <Item name="provider_name">
      <Input placeholder="Provider name" data-test={DATA_TEST.provider_name} />
    </Item>
    <Label>Request Special Preferences</Label>
    <Item name="special_needs">
      <TextArea
        autoSize={{ minRows: 2, maxRows: 10 }}
        rows={6}
        placeholder="Special Preferences"
        data-test={DATA_TEST.special_needs}
      />
    </Item>
  </>
)

export default FindCareFields
